
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"15","height":"13","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.563.464L.156 10.555A1 1 0 001 12.091h12.813a1 1 0 00.845-1.536L8.25.465a1 1 0 00-1.688 0z","fill":"#FF5853","fill-rule":"evenodd"}})])
      }
    
      }
    